<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import ajax from './utils/ajax'
  import store from './vuex/store'
export default {
  name: 'App',
  store
}
</script>

<style>
#app {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  padding: 0;
  margin: 0;
  font-size: 16px;
}
  a {
    text-decoration: none;
  }

  body {
    margin: 0;
    padding: 0;
  }

  .row {
    margin-top: 10px;
  }


</style>



// WEBPACK FOOTER //
// src/App.vue